module.exports = __webpack_public_path__ + "img/native.a0922a78.png";